export default __webpack_public_path__ + "static/media/led1_up_overay.57a2590d.svg";